import { DataTable, EditorialTable } from '@cdm/quickenloans-library/lib';
import { domToReact } from 'html-react-parser';
import React from 'react';
import { cdmTable, testAttributes, wpBlockGetwidTable } from './Constants';
import findDomElement from '../../../../findDomElement';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';

export const getChildAsReact = (element, replaceFn ) => element ? domToReact(element?.children, replaceFn() ) : undefined

export const getGrandChildrenElements = (element, type, childType, grandChildType ) =>
{
    const targetElement = findDomElement({ element, targetName: type });

    if (!targetElement) return [];

    const childrenOfType = targetElement.children.filter(
        (child) => child.name === childType
    );

    return childrenOfType?.map((row) => row.children.filter((child) => child.name === grandChildType));
}

export const getGrandChildrenValues = (elements, replaceFn) => elements?.map( el => getChildAsReact(el, replaceFn) );

export const mapAttributeToReact = (attribute) =>
{
    const [key, value] = Object.entries(attribute)?.at(0);
    const allowedAttributes = {
        colspan: 'colSpan',
        rowspan: 'rowSpan',
    }
    const mappedAttribute = allowedAttributes[key] || key;

    return { [mappedAttribute]: value}
}

export const extractTableMetadataFromTableElements = (elements, hasHeader = true) => elements.reduce((prevRow, row, y) =>
{
    const cells = row.reduce((prevCell, currCell, x) =>
    {
        if (
            !('attribs' in currCell) ||
            Object.keys(currCell.attribs).length === 0
        )
        {
            return prevCell;
        }

        const cellKey = `${hasHeader ? y + 1: y},${x}`;
        return {
            ...prevCell,
            [cellKey]: {
                props: mapAttributeToReact(currCell.attribs),
            },
        };
    }, {});

    return {
        ...prevRow,
        ...cells,
    };
}, {});

const toTable = (parserData) =>
{
    const { parserOptions: { replaceFn } } = parserData;

    const Wrapper = ({
        name = parserPropTypesDefaults.name,
        type = parserPropTypesDefaults.type,
        attribs = parserPropTypesDefaults.attribs,
        children = parserPropTypesDefaults.children
    }) =>
    {
        if (type !== 'tag') return null;
        if (!name || name !== 'figure') return null;
        if (!attribs?.class) return null;
        if (!attribs.class.includes(cdmTable)) return null;
        if (!Array.isArray(children)) return null;

        const isEditorial = attribs['data-tabletype'] === 'editorial';
        const TableComponent = isEditorial ? EditorialTable : DataTable;

        const headerElement = children.find(
            (child) => child.type === 'tag' && child.name === 'h3'
        );
        const title = getChildAsReact(
            headerElement.children.filter((child) => child.type === 'tag')?.at(0),
            replaceFn
        );

        const tableDivElement = children.find(
            (child) =>
                child.type === 'tag' &&
                child.attribs?.class.includes(wpBlockGetwidTable)
        );
        const tableHeadersElements = getGrandChildrenElements(
            tableDivElement,
            'thead',
            'tr',
            'th'
        );

        const tableRowsElements = getGrandChildrenElements(
            tableDivElement,
            'tbody',
            'tr',
            'td'
        );

        const figcaptionContent = getChildAsReact(
            findDomElement({ element: tableDivElement, targetName: 'figcaption' }),
            replaceFn
        );

        let metadata = {};
        const hasHeader = tableHeadersElements.length !== 0;

        metadata = {
            ...metadata,
            ...extractTableMetadataFromTableElements(tableRowsElements, hasHeader)
        }

        const tableProps = {
            ...(figcaptionContent ? { figcaptionContent } : undefined),
            metadata,
            tableData: [
                ...tableHeadersElements.map(el => getGrandChildrenValues(el, replaceFn)),
                ...tableRowsElements.map(el => getGrandChildrenValues(el, replaceFn)),
            ],
            testId: testAttributes.TABLE_CONTAINER,
            title: title.length || React.isValidElement(title) ? title : undefined,
        };

        return <TableComponent {...tableProps} />;
    };
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;

}

export default toTable;
